import React from "react";
import { useSelector } from "react-redux";
import Donut from "../../../../components/donut/donut";

export const DonutBreakdown = () => {
  const donuts = useSelector((state) => state.draft.chartsData.summaryBreakdown);
  const { currencySymbol } = useSelector((state) => state.commonReducer.commonProps);

  if (!donuts || !donuts.length) return null;

  return (
    <div>
      <div style={{ color: "#414042", fontSize: 15, fontWeight: 700, marginBottom: 10 }}>
        Summary Breakdown
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: donuts.length > 1 ? "space-around" : "flex-start",
          marginLeft: 10
        }}
      >
        {donuts.map((donut) => (
          <Donut
            key={donut.label}
            type={donut.label}
            value={donut.percent}
            dollarValue={donut.total}
            currencySymbol={currencySymbol}
            decimal={2}
            fontSize={21}
            hidePercentChanged
          />
        ))}
      </div>
    </div>
  );
};
